import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-159">
      <div className="max-w-4xl mx-auto" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-161">
          {/* Price */}
          <div className="mb-12" data-id="element-162">
            <p className="text-gray-600 text-lg mb-4" data-id="element-163">Oferta de lanzamiento</p>
            <div className="flex items-center justify-center gap-4 mb-6" data-id="element-164">
              <span className="text-3xl sm:text-4xl font-bold text-gray-400 line-through" data-id="element-165">
                $17
              </span>
              <span className="text-6xl sm:text-7xl font-black text-teal" data-id="element-166">
                $10
              </span>
            </div>
            <div className="inline-block bg-teal/10 border-2 border-teal rounded-full px-6 py-2 mb-6" data-id="element-167">
              <p className="text-teal font-bold text-lg" data-id="element-168">¡Ahorra $7 hoy!</p>
            </div>
            <p className="text-xl text-gray-700 max-w-2xl mx-auto" data-id="element-169">
              Es menos que una comida rápida… y te puede devolver horas cada
              semana.
            </p>
          </div>

          {/* Guarantee */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} className="bg-gray-50 rounded-xl p-8 mb-12 border-2 border-gray-200" data-id="element-170">
            <div className="flex items-center justify-center mb-4" data-id="element-171">
              <ShieldCheckIcon className="w-12 h-12 text-teal" aria-hidden="true" data-id="element-172" />
            </div>
            <h3 className="text-2xl font-bold text-navy mb-4" data-id="element-173">
              Micro-garantía
            </h3>
            <p className="text-gray-700 leading-relaxed max-w-2xl mx-auto" data-id="element-174">
              Si lo aplicas 7 días (de verdad) y sientes que no te dio ninguna
              mejora medible, te quedas con las plantillas y el protocolo de
              emergencia para usar en exámenes.
            </p>
          </motion.div>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5,
          duration: 0.6
        }} data-id="element-175">
            <CTAButton size="large" className="mb-6" href="https://tusistemasimple.com/cart/47523415556148:1" data-id="element-176">
              Descarga RESET de Scroll (7 días)
            </CTAButton>
            <div className="space-y-2 text-sm text-gray-600" data-id="element-177">
              <p data-id="element-178">✓ Acceso inmediato (PDF + plantillas)</p>
              <p data-id="element-179">✓ Funciona aunque hoy estés cansado/a</p>
              <p data-id="element-180">✓ Empieza con el Día 1 en 20 minutos</p>
            </div>
          </motion.div>

          {/* Final message */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.7,
          duration: 0.6
        }} className="mt-16 bg-navy rounded-xl p-8" data-id="element-181">
            <p className="text-2xl font-bold text-white mb-4" data-id="element-182">
              Empieza hoy con el Día 1: parking + registro.
            </p>
            <p className="text-xl text-gray-300" data-id="element-183">
              No necesitas sentirte listo/a. Solo necesitas empezar con{' '}
              <span className="text-teal font-bold" data-id="element-184">fricción.</span>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}